export default {"src":"/_next/static/media/vet.71d15925.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};